<template>
    <a :href="`${publicPath}${file}`" :title="title" :target="target" >
        <span v-if="showtitle" class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none" v-html="title"></span><span class="svg svg-pdf"></span>
    </a>
</template>

<script>
export default {
  props: {
    title: String,
    file: String,
    showtitle: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: "_blank"
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL+"Downloads/"
    }
  }
}
</script>
